import { post, get } from '@integec/fetch-task'

export const getBepcSppMapping = targetInfo =>
  get(targetInfo, 'bepc/bepc-spp-mapping')

export const postBepcSppMapping = targetInfo => data =>
  post(targetInfo, 'bepc/bepc-spp-mapping')(data)

export const deleteBepcSppMapping = targetInfo => data =>
  post(targetInfo, 'bepc/bepc-spp-mapping/delete')(data)
